import { render, staticRenderFns } from "./BpAppBanner.vue?vue&type=template&id=52228d08&"
import script from "./BpAppBanner.vue?vue&type=script&lang=js&"
export * from "./BpAppBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports